import * as ApiRequests from '../../api/requests';
import { GatewayListType } from '../../types';
import { AuthHelper } from '../../types/auth-helper-types';
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getDeviceChannelCount = async (authHelper: AuthHelper, siteId: string, gatewayId: string, deviceType: string) => {
    const deviceChannelCountResponse = await ApiRequests.deviceChannelCount(
        {
            siteId: siteId,
            gatewayId: gatewayId,
            deviceType: deviceType,
            deviceId: '',
        },
        { authHelper }
    );
    if (!deviceChannelCountResponse.ok) {
        console.error(ApiRequests.extractErrorCodeWithMessage(deviceChannelCountResponse.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(deviceChannelCountResponse.response));
    }

    return deviceChannelCountResponse.response.data.deviceChannelCounts;
};

const getAlarmConfig = async (authHelper: AuthHelper, deviceId: string, channels: string[]): Promise<any> => {
    const alarmConfigResponse = await ApiRequests.getAlarmConfig(
        {
            deviceChannelKeys: [{ deviceId: deviceId, channels: channels }],
        },

        { authHelper }
    );
    if (!alarmConfigResponse.ok) {
        console.error(ApiRequests.extractErrorCodeWithMessage(alarmConfigResponse.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(alarmConfigResponse.response));
    }

    return alarmConfigResponse.response.data;
};

const getAlarmFilters = async (authHelper: AuthHelper, organizationId: string, userId: string): Promise<any> => {
    const userPreferencesResponse = await ApiRequests.getAlarmFilters(
        {
            organizationId: organizationId,
            userId: userId,
        },

        { authHelper }
    );
    if (!userPreferencesResponse.ok) {
        console.error(ApiRequests.extractErrorCodeWithMessage(userPreferencesResponse.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(userPreferencesResponse.response));
    }

    return userPreferencesResponse.response.value.data;
};

const getGatewayDevices = async (
    authHelper: AuthHelper,
    args: { siteId: string; profileId: string }
): Promise<GatewayListType[]> => {
    const result = await ApiRequests.getSiteGatewayList(
        {
            siteId: args.siteId,
            profileId: args.profileId,
        },
        { authHelper }
    );

    if (!result.ok) {
        console.error(ApiRequests.extractResponseNotOkMessage(result.response));
        throw new Error(ApiRequests.extractErrorCodeWithMessage(result.response));
    }
    return result.response.data.siteGateways || [];
};

export { getDeviceChannelCount, getAlarmConfig, getAlarmFilters, getGatewayDevices };
